import React, { useId, useState, useRef } from "react";
import "./FAQ.css";

const faqs = [
  { question: "هل الاستشارات في تحرر سرية؟",
    answer: "نعم، جميع جلسات الاستشارات والبيانات محمية وفق أعلى معايير الأمان والخصوصية." },
  { question: "هل التطبيق مناسب لجميع الأعمار؟",
    answer: "نعم، التطبيق مناسب ويأخذ بالاعتبار احتياجات جميع الفئات العمرية." },
  { question: "هل أقدر أجرب التطبيق مجانًا؟",
    answer: "يمكنك استخدام النسخة التجريبية مجانًا قبل الاشتراك." },
  { question: "كيف يتم اختيار الأخصائيين؟",
    answer: "يتم اختيار الأخصائيين وفق اعتماد مهني ومراجعة خبراتهم." },
  { question: "هل أقدر ألغي الاشتراك في أي وقت؟",
    answer: "نعم، يمكنك إلغاء الاشتراك بسهولة من الإعدادات." }
];

const BASE = process.env.PUBLIC_URL || "landing-page";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);
  const listRef = useRef([]);
  const baseId = useId();

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const onKeyNav = (e, index) => {
    if (!["ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) return;
    e.preventDefault();
    const last = faqs.length - 1;
    let next = index;
    if (e.key === "ArrowDown") next = index === last ? 0 : index + 1;
    if (e.key === "ArrowUp")   next = index === 0 ? last : index - 1;
    if (e.key === "Home")      next = 0;
    if (e.key === "End")       next = last;
    listRef.current[next]?.focus();
  };

  return (
    <section className="faq" dir="rtl" aria-labelledby={`${baseId}-title`}>
      <div className="faq__header">
        <h2 id={`${baseId}-title`}>
          كل ما تحتاج <span>لمعرفته</span>
        </h2>
        <p>هذه الأسئلة الأكثر شيوعًا عنا.</p>
      </div>

      <div className="faq__list" role="list">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          const panelId = `${baseId}-panel-${index}`;
          const btnId = `${baseId}-button-${index}`;

          return (
            <div key={index} className={`faq__item ${isOpen ? "open" : ""}`} role="listitem">
              <button
                id={btnId}
                ref={(el) => (listRef.current[index] = el)}
                className="faq__question"
                onClick={() => toggleFAQ(index)}
                onKeyDown={(e) => onKeyNav(e, index)}
                aria-expanded={isOpen}
                aria-controls={panelId}
              >
                <span className="faq__icon">{isOpen ? "−" : "+"}</span>
                <span>{item.question}</span>
                <span className="faq__qmark">
                  <img
                    src={`${BASE}/assets/question.png`}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    decoding="async"
                  />
                </span>
              </button>

              <div
                id={panelId}
                role="region"
                aria-labelledby={btnId}
                className="faq__answer"
                hidden={!isOpen}
              >
                <div>
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
